import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from '../../design-system/components/Spinner';
import { useAuthStore } from './store';

type Role = 'closer' | 'manager' | 'admin';

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoles?: readonly Role[];
  /** Quando true, redireciona para / se o usuário não for platform admin. */
  requirePlatformAdmin?: boolean;
}

export function ProtectedRoute({
  children,
  allowedRoles,
  requirePlatformAdmin,
}: ProtectedRouteProps) {
  const status = useAuthStore((s) => s.status);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (status === 'idle' || status === 'bootstrapping') {
    return (
      <div className="center full-height">
        <Spinner label="Carregando" />
      </div>
    );
  }

  if (status === 'anonymous' || user === null) {
    return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
  }

  if (allowedRoles !== undefined) {
    const knownRoles: readonly string[] = allowedRoles;
    if (!knownRoles.includes(user.role)) {
      return <Navigate to="/" replace />;
    }
  }

  if (requirePlatformAdmin === true && !user.is_platform_admin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
